/** 이용가이드(노션 공개 사이트) 첫 페이지. 기능 사용법을 찾아 들어오는 진입점이 연다. */
export const USER_GUIDE_HOME_URL =
  "https://square-ounce-682.notion.site/3f729cf96d5f8001b08be02905e06c94";

/** 이용가이드의 빠른 시작 페이지. 처음 쓰는 사람을 안내하는 진입점이 연다. */
export const USER_GUIDE_QUICK_START_URL =
  "https://square-ounce-682.notion.site/3f829cf96d5f811ea68be21f7a0ad517";
